export default "__VITE_ASSET___gTTgL6Q__"